let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7A7U0")).then(() => parcelRequire('63Q5r'));